import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import type { ProductReviewReport } from '@jane/bloom/dataAccess/marketplace/productReviews.server';
import { ReviewIntent } from '@jane/bloom/routes/products.$productId.$slug.reviews/types';
import type { ActionResult } from '@jane/bloom/types/remixAction';
import { buildFormData } from '@jane/bloom/utils/formData';

type Args = {
  productId: number;
  productSlug?: string;
};

export function useReportReviewFetcher({ productId, productSlug }: Args) {
  const fetcher = useFetcher<ActionResult>();

  const handleSendReport = useCallback(
    (payloadData: ProductReviewReport) => {
      const formData = buildFormData({
        intent: ReviewIntent.Report,
        ...payloadData,
      });

      fetcher.submit(formData, {
        action: `/products/${productId}/${productSlug}/reviews`,
        method: 'post',
      });
    },
    [fetcher, productId, productSlug]
  );

  return {
    handleSendReport,
  };
}
